import React from 'react';
import styles from '@/styles/components/models-gallery/ModelCardSkeleton.module.css';

interface ModelCardSkeletonProps {
  className?: string;
}

const ModelCardSkeleton: React.FC<ModelCardSkeletonProps> = ({ className }) => {
  return (
    <article 
      className={`${styles.skeletonCard} ${className || ''}`}
      role="status"
      aria-label="Loading model information"
    >
      {/* Header */}
      <div className={styles.header}>
        <div className={styles.titleSection}>
          <div className={`${styles.skeleton} ${styles.title}`} />
          <div className={styles.licenseBadge}>
            <div className={`${styles.skeleton} ${styles.licenseIcon}`} />
            <div className={`${styles.skeleton} ${styles.licenseText}`} />
          </div>
        </div>
        <div className={`${styles.skeleton} ${styles.pricing}`} />
      </div>

      {/* Description */}
      <div className={styles.descriptionSection}>
        <div className={`${styles.skeleton} ${styles.descriptionLine1}`} />
        <div className={`${styles.skeleton} ${styles.descriptionLine2}`} />
        <div className={`${styles.skeleton} ${styles.descriptionLine3}`} />
      </div>

      {/* Tags */}
      <div className={styles.tagsSection}>
        <div className={styles.tags}>
          <div className={`${styles.skeleton} ${styles.tag}`} />
          <div className={`${styles.skeleton} ${styles.tag}`} />
          <div className={`${styles.skeleton} ${styles.tag}`} />
        </div>
      </div>

      {/* Actions */}
      <div className={styles.actions}>
        <div className={`${styles.skeleton} ${styles.chatButton}`} />
      </div>
    </article>
  );
};

export default ModelCardSkeleton;